import { apiRequest } from '@zr/utilities/api';

const IS_MOBILE_PARAM = 'is_mobile';

async function ajaxHeroRequest(fetchUrl) {
  // The UA isn't being sent with AJAX requests (TODO: can it be?), so we need to use a param to get the mobile jobs list.
  if (zr.page.model.isMobile) {
    fetchUrl.searchParams.set(IS_MOBILE_PARAM, '1');
  }
  const headers = {
    'ZR-SuperSet-Id': window.zr.page.model.superSetID,
    'ZR-SuperSet-Viewer-Id': window.zr.page.model.superSetViewerID,
  };

  const res = await apiRequest(fetchUrl.toString(), { headers }, '', true);
  const html = await res.text();
  return html;
}

async function fetchReportJobModalHtml() {
  const fetchUrl = new URL('/ajax/report_job', window.location.href);
  const filtersHtml = await ajaxHeroRequest(fetchUrl);
  $('main').append(filtersHtml);
  return true;
}


export { ajaxHeroRequest, fetchReportJobModalHtml };
